const defaultType = // eslint-disable-line
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const downloadFile = (file, name = 'Отчет', type = defaultType) => {
  const blob = new Blob([file], {
    type,
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.setAttribute('download', name);
  link.href = url;
  link.target = '_blank';
  link.style.display = 'none';
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default downloadFile;
